import { Expose, Type } from 'class-transformer';
import { ContactPerson } from './contact-person.model';
import { Customer } from '../../customers/models/customer.model';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { LocationModel } from '../../customers/models/location.model';
import { User } from '../../users/models/user.model';

export class Receiver extends DropdownModel {
  @Expose() id: number = null;
  @Expose() code: number = null;
  @Expose() name: string;

  @Type(() => LocationModel)
  @Expose() locations: LocationModel[] = [];

  @Type(() => ContactPerson)
  @Expose() contactPerson: ContactPerson[] = [];

  @Type(() => User)
  @Expose() createdBy: User;

  @Type(() => User)
  @Expose() updatedBy: User;


  @Expose() createdAt: number;
  @Expose() updatedAt: number;

  @Type(() => Customer)
  @Expose() customer: Customer = new Customer();

  @Expose() receiverType: string;

  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): Object {
    return this;
  }
}
